export enum AttachmentUsageContextTypeEnum {
  Item = 'item',
  Event = 'event',
  PublicProfile = 'publicProfile',
  Collection = 'collection',
  Slider = 'slider',
  Thumbnail = 'thumbnail'
}
